import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterLink } from '@angular/router';
import { Store } from '@ngxs/store';
import { LearnizState, NumberTitlePipe, SafeHtmlPipe, WordingPipe } from '@jump-tools-front/shared';

@Component({
  selector: 'learniz-landing-summary',
  templateUrl: './landing-summary.component.html',
  styleUrls: ['../landing-section.scss', './landing-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatExpansionModule, NgClass, RouterLink, AsyncPipe, NumberTitlePipe, WordingPipe, SafeHtmlPipe],
})
export class LandingSummaryComponent {
  private _store = inject(Store);
  readonly model$ = this._store.select(LearnizState.getLearniz);

  getLinkChapter(index: number): string {
    return `../chapter/${index}/0`;
  }

  getLinkSlide(index: number): string {
    return `../chapter/0/${index}`;
  }
}
